
import React from 'react';
import AwaitingInput from './AwaitingInput';

const ComingSoon = () => {
  return (
    <AwaitingInput
      title="Coming Soon"
      message=""
    />
  );
};

export default ComingSoon;
